import uniqid from "uniqid";
import toadstool from "../images/toadstoolLeather.jpg";
import finger from "../images/fingerCoral.jpg";
import gorgonian from "../images/gorgonian.jpg";
import clove from "../images/clovePolyp.jpg";
import pipe from "../images/pipeOrgan.jpg";
import candy from "../images/candyCane.jpg";
import duncan from "../images/duncan.jpg"
import mushroom from "../images/mushroom.jpg";
import chalice from "../images/chalice.jpg";
import scoly from "../images/scoly.jpg";
import frogspawn from "../images/frogspawn.jpg";
import galaxea from "../images/galaxea.jpg";
import anacorapora from "../images/anacropora.jpg"
import acropora from "../images/acropora.jpg";
import cyphastrea from "../images/cyphastrea.jpg";
import blueTort from "../images/blueTort.jpeg";
import stylophora from "../images/stylophora.jpg";
import monti from "../images/monti.jpg";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

const data = [
  {
    name: "Toadstool Leather",
    scientificName: "Sarcophyton glaucum",
    price: 50,
    type: "Soft",
    care: "easy",
    light: "low-moderate",
    flow: "low-medium",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: toadstool,
  },
  {
    name: "Finger Leather",
    scientificName: "Sinularia flexibilis",
    price: 50,
    type: "Soft",
    care: "easy",
    light: "moderate",
    flow: "high",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: finger,
  },
  {
    name: "Gorgonian",
    scientificName: "Gorgonia sp.",
    price: 50,
    type: "Soft",
    care: "easy",
    light: "high",
    flow: "high",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: gorgonian,
  },
  {
    name: "Green Clove Polyp",
    scientificName: "Clavularia sp.",
    price: 20,
    type: "Soft",
    care: "easy",
    light: "medium",
    flow: "high",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: clove,
  },
  {
    name: "Pipe Organ",
    scientificName: "Tubipora sp.",
    price: 40,
    type: "Soft",
    care: "easy",
    light: "medium",
    flow: "high",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: pipe,
  },
  {
    name: "Discosoma Mushroom",
    scientificName: "Discosoma sp.",
    price: 30,
    type: "Soft",
    care: "easy",
    light: "low",
    flow: "low",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: mushroom,
  },
  // LPS
  {
    name: "Candy Cane",
    scientificName: "Caulastrea sp.",
    price: 20,
    type: "LPS",
    care: "easy",
    light: "low",
    flow: "low",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: candy,
  },
  {
    name: "Duncan",
    scientificName: "Duncanopsammia axifuga",
    price: 40,
    type: "LPS",
    care: "easy",
    light: "medium",
    flow: "medium",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: duncan,
  },
  {
    name: "Chalice",
    scientificName: "Echinopora, Oxypora, Mycedium, Lithophyllon sp.",
    price: 50,
    type: "LPS",
    care: "easy",
    light: "low",
    flow: "low",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: chalice,
  },
  {
    name: "Scolymia",
    scientificName: "Scolymia australis",
    price: 100,
    type: "LPS",
    care: "moderate",
    light: "medium",
    flow: "low",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: scoly,
  },
  {
    name: "Frogspawn",
    scientificName: "Euphyllia sp.",
    price: 80,
    type: "LPS",
    care: "easy",
    light: "medium",
    flow: "medium",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: frogspawn,
  },
  {
    name: "Galaxea",
    scientificName: "Galaxea astreata",
    price: 40,
    type: "LPS",
    care: "moderate",
    light: "medium",
    flow: "medium",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: galaxea,
  },

  // SPS
  {
    name: "Acropora",
    scientificName: "Acropora sp.",
    price: 40,
    type: "SPS",
    care: "expert",
    light: "medium",
    flow: "medium",
    feeding: "NPS",
    id: uniqid(),
    cartQty: 0,
    imgURL: acropora,
  },
  {
    name: "Anacropora forbesi",
    scientificName: "Anacropora forbesi",
    price: 70,
    type: "SPS",
    care: "moderate",
    light: "medium",
    flow: "high",
    feeding: "NPS",
    id: uniqid(),
    cartQty: 0,
    imgURL: anacorapora,
  },
  {
    name: "Cyphastrea",
    scientificName: "Cyphastrea",
    price: 60,
    type: "SPS",
    care: "moderate",
    light: "low",
    flow: "medium",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: cyphastrea,
  },
  {
    name: "Oregon Blue Tort",
    scientificName: "Acropora sp.",
    price: 120,
    type: "SPS",
    care: "moderate",
    light: "high",
    flow: "high",
    feeding: "NPS",
    id: uniqid(),
    cartQty: 0,
    imgURL: blueTort,
  },
  {
    name: "Pink Stylophora",
    scientificName: "Stylophora sp.",
    price: 80,
    type: "SPS",
    care: "moderate",
    light: "medium",
    flow: "high",
    feeding: "NPS",
    id: uniqid(),
    cartQty: 0,
    imgURL: stylophora,
  },
  {
    name: "Montipora digita",
    scientificName: "Montipora digita",
    price: 60,
    type: "SPS",
    care: "moderate",
    light: "high",
    flow: "high",
    feeding: "photosynthetic",
    id: uniqid(),
    cartQty: 0,
    imgURL: monti,
  },
];

export {data, formatter};